import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { deletePromptById } from '../api/data-connectors/delete-prompt'
import { useNotification } from './useNotification'

export function useDeletePrompt() {
  const queryClient = useQueryClient()
  const { notify } = useNotification()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ promptId }: { promptId: string }) => deletePromptById(promptId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['prompts'] })
      notify({ isSuccess: true, text: t('prompts.deleteSuccessToast'), position: 'bottom' })
    },
    onError: () => {
      notify({ isSuccess: false, text: t('prompts.deleteFailureToast'), position: 'bottom' })
    },
  })
}
